import gql from 'graphql-tag';

const FULL_DELETE_ORG = gql`
  mutation fullDeleteOrg($Id: ID!, $confirmFullDelete: Boolean!) {
    fullDeleteOrg(where: { id: $Id }, confirmFullDelete: $confirmFullDelete) {
      id
    }
  }
`;

export default FULL_DELETE_ORG;
